import React, { useState, useEffect, useRef } from "react";
import { getUserEntity, signOutSubmit, switchEntity } from "../../redux/features/auth/authService";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from './index.module.css';
import ToggleIcon from '../../assets/images/icons/toggle_icon.png';
import { incrementEntityVersion, selectUserDetails, selectUserEntityDetails } from "../../redux/features/auth/authSlice";
import DefaultImage from '../../assets/images/icons/blank_profile_pic.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faArrowRight, faList, faUser } from "@fortawesome/free-solid-svg-icons"
import LogoutIcont from '../../assets/images/icons/logout_icon.png';
import { getActiveCertificateEntities } from "../../redux/features/certificateEntity/certificateEntityService";
import { selectActiveCertificateList } from "../../redux/features/certificateEntity/certificateEntitySlice";
import { showToast } from "../ToastMsg";

const Header = ({ toggleSidebar }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { pathname } = location;
    const { roleName, details } = useSelector(selectUserDetails);
    const { status, data: activeCertificateEntities } = useSelector(selectActiveCertificateList);
    const { user_certificate_entity } = useSelector(selectUserEntityDetails);

    const [isOpen, setOpen] = useState(false);
    const dropdownRef = useRef(null);
    const entityDropdownRef = useRef(null);

    const role = pathname.split('/')[1];
    const splitAfterRole = pathname.split(`/${role}/`)[1];
    const pathSegments = splitAfterRole ? splitAfterRole.split('/') : [];
    const displaySegments = pathSegments.filter(segment => isNaN(segment)).slice(0, -1);

    const [isMobileView, setIsMobileView] = useState(false);

    useEffect(() => {
        dispatch(getActiveCertificateEntities());
    }, [dispatch]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 430);
        };
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleLogout = async () => {
        try {
            await dispatch(signOutSubmit()).unwrap();
        } catch (error) {
            console.error("Logout failed:", error);
        } finally {
            navigate("/login", { replace: true });
        }
    };

    const createLinkPath = (index) => {
        const basePath = `/${role}/`;
        const dynamicPath = pathSegments.slice(0, index + 1).join('/');
        return `${basePath}${dynamicPath}`;
    };

    const getActivityLogs = () => {
        if (roleName === 'admin') {
            navigate('/admin/my-activities');
        }
    };

    const getProfile = () => {
        if (roleName === 'admin') {
            navigate('/admin/my-profile');
        }
    };

    const [isEntityOpen, setIsEntityOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);

    const toggleDropdown = () => setIsEntityOpen((prev) => !prev);

    const onOptionClicked = async (value) => {
        setIsEntityOpen(false);
        try {
            await dispatch(
                switchEntity({ entity_token: value, prev_entity_token: user_certificate_entity })
            ).unwrap();
            await dispatch(
                getUserEntity()
            ).unwrap();
            dispatch(incrementEntityVersion());
        } catch (error) {
            showToast('error', error.message);
        }
    };

    const handleClickOutside = (event) => {
        if (entityDropdownRef.current && !entityDropdownRef.current.contains(event.target)) {
            setIsEntityOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <header className={styles.header}>
            <div className={styles.leftSec}>
                <div className={styles.toggleHeader}>
                    <img
                        src={ToggleIcon}
                        className={styles.toggleBtn}
                        alt="toggle"
                        onClick={toggleSidebar}
                    />
                </div>
                <div>
                    {/* {isMobileView ? (
                        <span className={styles.currentSegment}>
                            {displaySegments[displaySegments.length - 1]
                                ?.replace(/-/g, ' ')
                                ?.replace(/\b\w/g, char => char.toUpperCase())}
                        </span>
                    ) : (
                        displaySegments.map((segment, index) => (
                            <span key={index} className={styles.pathDivider}>
                                {index < displaySegments.length - 1 ? (
                                    <Link
                                        to={createLinkPath(index)}
                                        className={styles.previousSegment}
                                    >
                                        {segment
                                            .replace(/-/g, ' ')
                                            .replace(/\b\w/g, char => char.toUpperCase())}
                                    </Link>
                                ) : (
                                    <span className={styles.currentSegment}>
                                        {segment
                                            .replace(/-/g, ' ')
                                            .replace(/\b\w/g, char => char.toUpperCase())}
                                    </span>
                                )}
                                {index < displaySegments.length - 1 && ' > '}
                            </span>
                        ))
                    )} */}
                    <div style={{ width: '100px', position: 'relative' }} ref={entityDropdownRef}>
                        <button
                            onClick={toggleDropdown}
                            className={styles.dropdownButton}
                            style={{ width: '100%', padding: '10px', textAlign: 'left' }}
                        >
                            {user_certificate_entity || "Select"}
                            <span style={{ float: 'right' }}>
                                {isEntityOpen ? '▲' : '▼'}
                            </span>
                        </button>

                        {isEntityOpen && (
                            <ul className={styles.entityDropdownMenu}>
                                {activeCertificateEntities.map((option) => (
                                    <li
                                        key={option.id}
                                        onClick={() => onOptionClicked(option?.code)}
                                        style={{ padding: '10px', cursor: 'pointer' }}
                                        className={
                                            user_certificate_entity === option?.code
                                                ? styles.selectedValue
                                                : ''
                                        }
                                    >
                                        {option?.code}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                </div>
            </div>
            <div
                className={styles.profileSec}
                onClick={() => setOpen(!isOpen)}
                ref={dropdownRef}
            >
                <img
                    src={details?.image_url ? details?.image_url : DefaultImage}
                    className={styles.imageSec}
                />
                {!isMobileView ? (
                    <div className={styles.detailsSec}>
                        <p className={styles.profileName}>{details?.full_name}</p>
                        <p className={styles.profileRole}>
                            {roleName
                                ?.split("_")
                                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                .join(" ")
                            }
                        </p>
                    </div>
                ) : null}
                <FontAwesomeIcon icon={faAngleDown} color="#9FA6B2" />
                {isOpen ? (
                    <ul className={styles.dropdownMenu}>
                        <li className={styles.dropdownItem} onClick={getActivityLogs}>
                            <FontAwesomeIcon icon={faList} width={24} /> My Activities
                        </li>
                        <li className={styles.dropdownItem} onClick={getProfile}>
                            <FontAwesomeIcon icon={faUser} width={24} /> My Profile
                        </li>
                        <li onClick={handleLogout} className={styles.dropdownItem}>
                            <FontAwesomeIcon icon={faArrowRight} width={24} />Logout
                        </li>
                    </ul>
                ) : null}
            </div>
        </header>
    );
};

export default Header;